import { Ability } from '@casl/ability';
import { Actions, Subjects } from '../types';

const ability = new Ability<[Actions, Subjects]>();

export default ability;
